export default __webpack_public_path__ + "invision.9bea659f.png";